module.exports = __webpack_public_path__ + "img/vertical_7_4_0.d2bfb4f8.png";